import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';
import clsx from 'clsx';
import { useBreakpoints } from 'hooks';

import { Responsive } from 'components/_basic/Responsive';

import { IFieldArrayComponentProps } from './types';
import { AddButton } from '../components/AddButton';
import { RemoveButton } from '../components/RemoveButton';

import styles from './FieldArrayComponent.module.scss';

export const FieldArrayComponent: React.FC<IFieldArrayComponentProps> = ({
  name,
  buttonText,
  initialItem,
  maxLength = 5,
  fieldArrayStyles,
  notRequired = true,
  children,
  disabled = false,
}) => {
  const { control } = useFormContext();
  const { isMobile } = useBreakpoints();

  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const handleAddRow = () => {
    append(initialItem);
  };

  const canAddMore = fields.length < maxLength;
  const canRemove = fields.length > 1;

  return (
    <Box>
      <Box className={fieldArrayStyles?.container}>
        {fields.map((item, index) => (
          <Box
            key={item.id}
            className={clsx(styles.rowContainer, fieldArrayStyles?.rowContainer, {
              [styles['rowContainer--mobile']]: isMobile,
            })}
          >
            <Box className={styles.rowChildren}>{children(`${name}.${index}`, index, () => remove(index))}</Box>
            <Responsive aboveMobile>
              <RemoveButton
                canRemove={canRemove}
                notRequired={notRequired}
                buttonStyles={fieldArrayStyles?.removeButton}
                disabled={disabled}
                onClick={() => remove(index)}
              />
            </Responsive>
          </Box>
        ))}
      </Box>
      <AddButton
        canAddMore={canAddMore}
        onClick={handleAddRow}
        className={fieldArrayStyles?.addButton}
        variant="text"
        disabled={disabled}
      >
        {buttonText}
      </AddButton>
    </Box>
  );
};
